import secureLocalStorage from "react-secure-storage";

class TokenService {
	setToken(token) {
		secureLocalStorage.setItem("token", token);
	}

	setUser(user) {
		secureLocalStorage.setItem("user", JSON.stringify(user));
	}

	setEventStatus(status) {
		secureLocalStorage.setItem("status", status);
	}

	getToken() {
		const token = secureLocalStorage.getItem("token");
		return token;
	}

	getUser() {
		const user = JSON.parse(secureLocalStorage.getItem("user"));
		return user;
	}

	getEventStatus() {
		const status = secureLocalStorage.getItem("status");
		return status;
	}

	removeToken() {
		secureLocalStorage.removeItem("token");
	}

	removeUser() {
		secureLocalStorage.removeItem("user");
	}

	removeEventStatus() {
		secureLocalStorage.removeItem("status");
	}

	clearStorage() {
		secureLocalStorage.clear();
	}
}

export default new TokenService();
